<template>
  <a-row
    type="flex"
    justify="space-around"
    align="middle"
    class="fit-block fit-block__mobile"
    style="padding: 0 !important"
  >
    <a-col :lg="5" :md="20" :sm="20" :xs="20">
      <div class="dash-text__122 dash-text__500 dash-text__purple">
        <span>404</span>
      </div>
      <div
        class="dash-text__25 dash-text__700 dash-text__white dash-text__uppercase"
      >
        {{ $t("Page not found") }}
      </div>
      <div class="dash-text__16 dash-text__500 dash-text__white m-t-10">
        {{ $t("Page not found about") }}
      </div>
      <div class="m-t-20">
        <a-button
          class="upload-button little-radius"
          @click="$router.push('/')"
        >
          <span>{{ $t("Back to main page") }}</span>
          <i class="fa-light fa-chevron-right m-l"></i>
        </a-button>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import metaMixin from "Helpers/metaMixin";

export default {
  mixins: [metaMixin],
  created() {
    this.$store.dispatch("updateModule", undefined);
  },
};
</script>
